import InfoPanelContainer from './info-panel-container';

export default InfoPanelContainer;
